<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />

    <div class="d-flex justify-content-center align-items-center">
      {{ name }}
    </div>

    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CImg src="../../../img/ictcenter.png" height="48" align="center"></CImg>

      <!-- <CIcon name="logo" height="48" alt="Logo" /> -->
    </CHeaderBrand>

    <!-- ********************************************************************** statistics -->

    <!-- <CRow
      v-if="this.$route.name == 'Dashboard'"
      class="align-items-center d-md-down-none col-7"
    >
      <CRow class="col">
        <CInput :placeholder="total" disabled class="m-0 p-0 align-self-center">
          <template #prepend>
            <CButton color="info" @click="setData">
              <CIcon name="cil-memory" /> تعداد کل
            </CButton>
          </template>
        </CInput>
      </CRow>

      <CRow class="col">
        <CInput
          :placeholder="active"
          disabled
          class="m-0 p-0 align-self-center"
        >
          <template #prepend>
            <CButton color="success">
              <CIcon name="cil-memory" /> فعال
            </CButton>
          </template>
        </CInput>
      </CRow>

      <CRow class="col">
        <CInput
          :placeholder="inActive"
          disabled
          class="m-0 p-0 align-self-center"
        >
          <template #prepend>
            <CButton color="danger">
              <CIcon name="cil-memory" /> غیرفعال
            </CButton>
          </template>
        </CInput>
      </CRow>
    </CRow> -->

    <CHeaderNav class="d-md-down-none mr-auto">
      <!-- <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard"> Dashboard </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/users" exact> Users </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink> Settings </CHeaderNavLink>
      </CHeaderNavItem> -->
    </CHeaderNav>

    <CHeaderNav class="mr-4">
      <!-- <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-magnifying-glass" :click="searchBox()" />
        </CHeaderNavLink>
        <div
          class="dropdown-menu"
          style="
            position: absolute;
            inset: 0px auto auto 0px;
            margin: 0px;
            transform: translate(10px, 36px);
          "
        >
          <div class="arrow_box">
            <form>
              <div class="input-group search-box">
                <div class="position-relative has-icon-right full-width">
                  <input
                    class="form-control"
                    id="search"
                    type="text"
                    placeholder="Search here..."
                  />
                  <div class="form-control-position navbar-search-close">
                    <i class="ft-x"></i>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </CHeaderNavItem> -->

      <!-- <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-bell" />
        </CHeaderNavLink>
      </CHeaderNavItem> -->

      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CButton @click="alarmList()">
            <CIcon name="cil-bell" /><spam class="text-danger">{{
              numberOfAlert
            }}</spam></CButton
          >
        </CHeaderNavLink>
      </CHeaderNavItem>

      <!-- <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-list" />
        </CHeaderNavLink>
      </CHeaderNavItem> -->

      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CButton @click="messageList()">
            <CIcon name="cil-envelope-open" /><spam class="text-danger">{{
              numberOfMessage
            }}</spam></CButton
          >
        </CHeaderNavLink>
      </CHeaderNavItem>

      <TheHeaderDropdownAccnt />
    </CHeaderNav>
    <div></div>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

import axios from "axios";
import { Values } from "../commonValues";
// import $ from "jquery";

import { HubConnectionBuilder, HttpTransportType } from "@aspnet/signalr";
import router from "../router";

import Vue from "vue";
import VueNotification from "@kugatsu/vuenotification";
Vue.use(VueNotification, {
  timer: 10,
  position: "bottomRight",
  showCloseIcn: true,
  showLeftIcn: false,
});

import { eventBus } from "../main.js";

const audio = new Audio("../../../sound/alarm.mp3");

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
  },

  data() {
    return {
      total: "--",
      active: "--",
      inActive: "--",
      numberOfAlert: 0,
      numberOfMessage: "",
      test: true,

      name: localStorage.getItem("name"),
    };
  },

  // computed: {
  //   total: function () {
  //    return Values.online;
  //   },
  // },

  watch: {
    numberOfAlert(newVal) {
      if (newVal > 0) {
        //this.playSound();
        audio.loop = true; // Set the audio to loop
        audio.play(); // Play the audio
      } else {
        audio.pause();
      }
    },
  },

  methods: {
    numberOfAlertMessage() {
      axios
        .get(Values.serverIp + "alarm/GetNumberOfAlarmsActive")
        .then((response) => {
          this.numberOfAlert = response.data > 0 ? response.data : 0;
          // response.data > 0 ? this.playSound() : "";
        });

      axios
        .get(Values.serverIp + "alarm/GetNumberOfAlarmsTracking")
        .then((response) => {
          this.numberOfMessage = response.data > 0 ? response.data : "";
        });
    },
    searchBox() {
      var $ = require("jquery");
      $(".dropdown-menu").addClass("show");
    },

    setData() {
      this.total = Values.online;
    },

    updataStatistice(data) {
      this.total = data.length;

      this.active = data.filter(function (el) {
        return el.carStatusId == 1;
        // el.dateTime.includes(data)
      }).length;

      this.inActive = data.filter(function (el) {
        return el.carStatusId == 2;
        // el.dateTime.includes(data)
      }).length;
    },

    alarmList() {
      router.push({ name: "Alarm" });
    },

    messageList() {
      router.push({ name: "Message" });
    },

    // playSound() {
    //   const audio = new Audio("../../../sound/alarm.mp3");
    //   audio.play();
    // },
  },

  created() {
    eventBus.$on("changeAlarmNum", (age) => {
      this.numberOfAlert = age;
      if (age < 1) {
        console.log(age);
        audio.pause();
      }
    });
  },

  mounted() {
    //this.playSound();
    //*************************************************** */
    if (localStorage.getItem("token"))
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("token")}`;

    this.numberOfAlertMessage();
    //********************************************************************** signalr */
    const hubConnection = new HubConnectionBuilder()
      .withUrl(Values.serverIp + "ActiveAlertHub", {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .build();

    hubConnection.start().then(() => {
      hubConnection.on("ActiveAlertHub", (data) => {
        console.log(data);

        axios
          .post(Values.serverIp + "alarm/GetAlarmForDevice", {
            deviceId: data.deviceId,
            sensorType: data.sensorType,
            sensorIndex: data.sensorIndex,
            state: data.state,
            periodicRepairsId: data.periodicRepairsId,
          })
          .then((response) => {
            console.log(response.data);
            this.numberOfAlertMessage();

            //this.$notification.new("hello worldkd askdfj askdfjas dfjaksd fjaskldf jaskldf jaskldfj askldfj asdfk");

            //this.playSound();
            audio.loop = true; // Set the audio to loop
            audio.play(); // Play the audio

            this.$notification.warning(response.data[0].description);

            //this.$notification.error("hello world");
            // if (response.status == 200 && response.data == "0") {
            //   this.addModal = false;
            //   this.alert = false;
            // } else {
            //   // modal unsuccessful edit change
            //   this.alertModal = true;
            //   this.alertModalTitle = "خطایی رخ داده";
            //   if (response.data == "1") {
            //     this.alertModalText =
            //       "خطا در ثبت اطلاعات لطفا دوباره تلاش کنید.";
            //   } else if (response.data == "2") {
            //     this.alertModalText =
            //       " ساختار سازمانی با این نام قبلا ثبت شده.";
            //   }
            //   this.alertModalColor = "warning";
            //   this.alertModalButtonText = "تایید";
            // }
          })
          .catch((response) => {
            if (response.response.status == 403) {
              // do not have permission
              // modal unsuccessful edit change
              (this.alertModal = true),
                // (this.showPage = false),
                (this.alertModalTitle = "عدم مجوز"),
                (this.alertModalText =
                  "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
                (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            }
          });
      });
    });
  },
};
</script>
